import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

/** OIDC IdP (Authentik / Keycloak) редиректит сюда после login.
 * react-oidc-context сам делает code→token exchange; мы только
 * ждём результата и перенаправляем на исходный deep-link из sessionStorage. */
export default function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const target = sessionStorage.getItem("mt:postLoginRedirect") ?? "/";
      sessionStorage.removeItem("mt:postLoginRedirect");
      navigate(target, { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  if (auth.error) {
    return (
      <div className="mt-empty mt-empty--error" role="alert">
        <h2>Не удалось завершить вход</h2>
        <p>{auth.error.message}</p>
      </div>
    );
  }

  return (
    <div className="mt-empty">
      <p>Завершаем вход…</p>
    </div>
  );
}
